import client from './client';

const prepApi = {
  // Notes
  getNotes(params = {})       { return client.get('/prep/notes', { params }).then(r => r.data.data); },
  createNote(data)            { return client.post('/prep/notes', data).then(r => r.data.data); },
  updateNote(id, data)        { return client.put(`/prep/notes/${id}`, data).then(r => r.data.data); },
  deleteNote(id)              { return client.delete(`/prep/notes/${id}`).then(r => r.data); },

  // Timetable
  getTimetable()              { return client.get('/prep/timetable').then(r => r.data.data); },
  saveTimetable(data)         { return client.put('/prep/timetable', data).then(r => r.data.data); },

  // Study Logs
  getLogs(params = {})        { return client.get('/prep/logs', { params }).then(r => r.data.data); },
  getStreak()                 { return client.get('/prep/logs/streak').then(r => r.data.data); },
  saveLog(data)               { return client.post('/prep/logs', data).then(r => r.data.data); },
  deleteLog(dateStr)          { return client.delete(`/prep/logs/${dateStr}`).then(r => r.data); },
};

export default prepApi;
